import { render, staticRenderFns } from "./FilesSearch.vue?vue&type=template&id=feef3f08&scoped=true"
import script from "./FilesSearch.vue?vue&type=script&lang=js"
export * from "./FilesSearch.vue?vue&type=script&lang=js"
import style0 from "./FilesSearch.vue?vue&type=style&index=0&id=feef3f08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feef3f08",
  null
  
)

export default component.exports